import { IonDate } from '../i-components/IonDate.tsx';

const CheckNotNull = Symbol('CheckNotNull');

class MemberUser {
    //non-updateable
    membership_registrationID: string =  '';
    userID: string  = '';
    memberID: string = '';
    type: string = '';
    committee_typeID: string = '';
    email_verified: boolean = false;
    status: number = 0;
    // reference_code_activation: string = ''; ---deprecated
    // expiry_date: Date = new Date(); ---deprecated
    last_login: Date = new Date();
    nric: string = '';
    date_of_birth: Date = new Date();
    datetime_created: Date = new Date();

    //updateable
    email: string = '';
    name: string = '';
    pin_number: string = '';
    profile_image: string = '';
    alternate_email: string = '';
    alternate_email_2: string = '';
    // place_of_birth: string = ''; ---deorecated
    // race: number = 0; ---deprecated
    // gender: number = 0; ---deprecated
    salutation: string = '';
    other_salutation: string = '';
    // nationality: string = '';
    // marital_status: number = 0; --deprecated
    office_tel_no: string = '';
    // fax: string = ''; --deprecated
    handphone_code: string = '';
    handphone_no: string = '';
    designation: string = '';
    nature_of_work: string = '';
    years_with_company: number = 0;
    academic_qualification: number = 0;
    address: string = '';

    constructor(
        //non updateable
        membership_registrationID: string,
        userID: string,
        memberID: string,
        type: string,
        committee_typeID: string,
        email_verified: string,
        status: string,
        // reference_code_activation: string,
        // expiry_date: string, ---deprecated
        last_login: string,
        nric: string,
        date_of_birth: string,
        datetime_created: string,
        //updateable
        email: string,
        name: string,
        pin_number: string,
        profile_image: string,
        alternate_email: string,
        alternate_email_2: string,
        // place_of_birth: string,
        // race: string,
        // gender: string, ---deprecated
        salutation: string,
        other_salutation: string,
        // nationality: string,
        // marital_status: string,
        office_tel_no: string,
        // fax: string,
        handphone_code: string,
        handphone_no: string,
        designation: string,
        nature_of_work: string,
        years_with_company: string,
        academic_qualification: string,
        address: string
    ) {
        //updateable
        this.membership_registrationID = this[CheckNotNull](membership_registrationID) ? membership_registrationID : '';
        this.userID = this[CheckNotNull](userID) ? userID : '';
        this.memberID = this[CheckNotNull](memberID) ? memberID : '';
        this.type = this[CheckNotNull](type) ? type : '';
        this.committee_typeID = this[CheckNotNull](committee_typeID) ? committee_typeID : '';
        this.email_verified = this[CheckNotNull](email_verified) ? (email_verified == '1' ? true : false) : false;
        this.status = this[CheckNotNull](status) ? parseInt(status) : 0;
        this.last_login = this[CheckNotNull](last_login) ? IonDate(last_login) : new Date();
        this.nric = this[CheckNotNull](nric) ? nric : '';
        this.date_of_birth = this[CheckNotNull](date_of_birth) ? IonDate(date_of_birth + ' 00:00:00') : new Date();
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : new Date();

        this.email = this[CheckNotNull](email) ? email : '';
        this.name = this[CheckNotNull](name) ? name : '';
        this.pin_number = this[CheckNotNull](pin_number) ? pin_number : '';
        this.profile_image = this[CheckNotNull](profile_image) ? profile_image : '';
        this.alternate_email = this[CheckNotNull](alternate_email) ? alternate_email : '';
        this.alternate_email_2 = this[CheckNotNull](alternate_email_2) ? alternate_email_2 : '';
        // this.place_of_birth = this[CheckNotNull](place_of_birth) ? place_of_birth : '';
        // this.race = this[CheckNotNull](race) ? parseInt(race) : 0;
        // this.gender = this[CheckNotNull](gender) ? parseInt(gender) : 0; --deprecated
        this.salutation = this[CheckNotNull](salutation) ? salutation : '';
        this.other_salutation = this[CheckNotNull](other_salutation) ? other_salutation : '';
        // this.nationality = this[CheckNotNull](nationality) ? nationality : '';
        // this.marital_status = this[CheckNotNull](marital_status) ? parseInt(marital_status) : 0;
        this.office_tel_no = this[CheckNotNull](office_tel_no) ? office_tel_no : '';
        // this.fax = this[CheckNotNull](fax) ? fax : '';
        this.handphone_code = this[CheckNotNull](handphone_code) ? handphone_code : '';
        this.handphone_no = this[CheckNotNull](handphone_no) ? handphone_no : '';
        this.designation = this[CheckNotNull](designation) ? designation : '';
        this.nature_of_work = this[CheckNotNull](nature_of_work) ? nature_of_work : '';
        this.years_with_company = this[CheckNotNull](years_with_company) ? parseInt(years_with_company) : 0;
        this.academic_qualification = this[CheckNotNull](academic_qualification) ? parseInt(academic_qualification) : 0;
        this.address = this[CheckNotNull](address) ? address : '';
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default MemberUser;